<!--
  The one card in the sidebar foot, above the profile block. It shows the
  first that applies (useShellNotices): a team invitation, then the upgrade
  call. One card at a time, so the foot stays one card high.

  The team invitation used to be a yellow bar above every page. It is also
  the first row of the bell. In the icon rail each card is its icon, and the
  invitation has a dot.
-->
<template>
  <InertiaLink
    v-if="footCard === 'invite' && teamInvite"
    v-tooltip="{
      content: 'Team invitation',
      placement: 'right',
      disabled: !isRail,
    }"
    href="/team/invitations"
    class="gm-sb-upgrade gm-sb-notice"
  >
    <UsersIcon class="gm-sb-upgrade-icon" aria-hidden="true" />
    <span class="gm-sb-notice-dot" aria-hidden="true" />
    <span class="gm-sb-upgrade-body">
      <span v-if="teamInvite.teamName">
        <b>{{ teamInvite.teamName }}</b>
        invited you to their team.
      </span>
      <span v-else>
        <b>You are invited</b>
        to a team.
      </span>
      <span class="gm-sb-upgrade-go">
        <span>See the invitation</span>
        <ArrowRightIcon aria-hidden="true" />
      </span>
    </span>
  </InertiaLink>

  <SidebarUpgradeCard
    v-else-if="footCard === 'upgrade' && upgradeKind"
    :is-rail="isRail"
    :kind="upgradeKind"
  />
</template>

<script setup lang="ts">
import UsersIcon from '~icons/lucide/users'
import ArrowRightIcon from '~icons/lucide/arrow-right'
import SidebarUpgradeCard from './SidebarUpgradeCard.vue'
import { useShellNotices } from './useShellNotices'

defineProps<{ isRail: boolean }>()

const { footCard, teamInvite, upgradeKind } = useShellNotices()
</script>

<style>
/* Unscoped, like the rest of the sidebar (see AppSidebar). The card itself
   is .gm-sb-upgrade. */
/* Somebody waits for an answer: the same dot as the bell, on the first line
   of the text. */
.gm-sb-notice-dot {
  position: absolute;
  top: 1.1875rem;
  right: 0.875rem;
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 999px;
  background: var(--color-error-500);
}
.gm-sb-notice:has(.gm-sb-notice-dot) .gm-sb-upgrade-body {
  padding-right: 1rem;
}
@container gm-sb (max-width: 7.5rem) {
  .gm-sb-notice-dot {
    top: 0.5rem;
    right: 0.5rem;
    box-shadow: 0 0 0 2px var(--gm-sb-card-bg);
    transition: box-shadow 120ms ease;
  }
}
</style>
